export const MAX_LIST_SIZE = 10;

export const SELECT_REVIEWER_EVENT = 'user_selects_reviewer_from_mr_sidebar';
export const SEARCH_SELECT_REVIEWER_EVENT = 'user_selects_reviewer_from_mr_sidebar_after_search';
